import { Box, Dialog, IconButton, OutlinedInput, Stack, TextField, Tooltip } from "@mui/material";
import { ContentCopy, Email, Facebook, LinkedIn, Twitter, WhatsApp } from "@mui/icons-material";
import {
	EmailShareButton,
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	WhatsappShareButton,
} from "react-share";
import React, { useState } from "react";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { useLocation } from "react-router-dom";

const ShareUi = (props) => {
	const { url, title } = props;
	const [copied, setCopied] = useState(false);

	return (
		<Box sx={{ padding: "1rem" }}>
			{/* Copy Link */}
			<Box>
				<OutlinedInput
					id='URL'
					label='Copy'
					variant='outlined'
					value={url}
					color='primary'
					focused
					endAdornment={
						<CopyToClipboard text={url} onCopy={() => setCopied(true)}>
							<Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
								<IconButton color='primary'>
									<ContentCopy />
								</IconButton>
							</Tooltip>
						</CopyToClipboard>
					}
					InputProps={{ readOnly: true }}
				/>
			</Box>
			<Stack direction='row' spacing={2} sx={{ justifyContent: "center" }}>
				{/* facebook */}
				<FacebookShareButton url={url} quote={title}>
					<Tooltip title='Share on Facebook'>
						<IconButton color='primary'>
							<Facebook />
						</IconButton>
					</Tooltip>
				</FacebookShareButton>
				{/* twitter */}
				<TwitterShareButton url={url} title={title}>
					<Tooltip title='Share on Twitter'>
						<IconButton color='primary'>
							<Twitter />
						</IconButton>
					</Tooltip>
				</TwitterShareButton>
				{/* whatsApp */}
				<WhatsappShareButton url={url} title={title}>
					<Tooltip title='Share on WhatsApp'>
						<IconButton color='primary'>
							<WhatsApp />
						</IconButton>
					</Tooltip>
				</WhatsappShareButton>
				{/* Email */}
				<EmailShareButton url={url} subject={title} body={url}>
					<Tooltip title='Share via Email'>
						<IconButton color='primary'>
							<Email />
						</IconButton>
					</Tooltip>
				</EmailShareButton>
			</Stack>
		</Box>
	);
};
const ShareDialog = (props) => {
	const { handleClose, open } = props;
	const location = useLocation();
	const currentUrl = `${window.location.origin}${location.pathname}${location.search}`;
	return (
		<Dialog onClose={handleClose} open={open}>
			<ShareUi url={currentUrl} title='coppy Blog Link' />
		</Dialog>
	);
};

export default ShareDialog;
